import { lazy } from 'react'

import { Stage } from '../application/stage'
import { CarDetailsCardSSR } from '../features/car-details-card/components/CarDetailsCardSSR'

/**
 * Объект, описывающий все стейджи, имеющиеся в приложении. Если вы хотите, чтобы ваш стейдж можно было отрендерить,
 * нужно добавить его в этот список
 */
export const stages = {
  AVN: lazy(() => import('stages/AVN')),
  CarDetails: lazy(() => import('stages/car-details')),
  CarsWidget: lazy(() => import('stages/cars-widget')),
  DealerLocator: lazy(() => import('stages/dealer-locator')),
  Form: lazy(() => import('stages/form')),
  HorizontalTGB: lazy(() => import('stages/horizontalTGB')),
  TileCards: lazy(() => import('stages/tileCards')),
  AccessoriesShowroom: lazy(() => import('stages/accessories/index'))
}

/**
 * Сюда нужно добавлять стейджи, которые можно ренедрить на SSR безопасно
 * (убедиться, что не испрользуется window, document, etc) за пределами useEffect()!!!
 */
export const SSRStages: Partial<Record<keyof typeof stages, Stage<any>>> = {
  CarDetails: CarDetailsCardSSR
}
